import { Validators } from "@angular/forms";
import { PolluxFormConfig } from "../../pollux-form-config/pollux-form-config";
import { PolluxFormDisabledEvaluator } from "../../pollux-form-disabled-evaluator/pollux-form-disabled-evaluator";


export const propertiesFormConfig: PolluxFormConfig[] = [
  {
    name: 'Street1',
    value: 'Street1',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(100)]
  }, {
    name: 'StreetNo1',
    value: 'StreetNo1',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(50)]
  }, {
    name: 'houseNoTo',
    value: 'houseNoTo',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  }, {
    name: 'houseNoAd',
    value: 'houseNoAd',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  }, {
    name: 'Street2',
    value: 'Street2',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(100)]
  }, {
    name: 'StreetNo2',
    value: 'StreetNo2',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(50)]
  }, {
    name: 'houseNo2To',
    value: 'houseNo2To',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  }, {
    name: 'houseNo2Ad',
    value: 'houseNo2Ad',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  }, {
    name: 'PostalCodeManual',
    value: 'PostalCodeManual',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  }, {
    name: 'MunicipalManual',
    value: 'MunicipalManual',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  }, {
    name: 'RegionManual',
    value: 'RegionManual',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  }, {
    name: 'subLocation',
    value: 'subLocation',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  }, {
    name: 'CountryID',
    value: 'CountryID',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  }, {
    name: 'Latitude',
    value: 'Latitude',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  }, {
    name: 'Longitude',
    value: 'Longitude',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  }, {
    name: 'coordinatesQuality',
    value: 'coordinatesQuality',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  }, {
    name: 'PropertyTypeCode',
    value: 'PropertyTypeCode',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  }, {
    name: 'PropertySubTypeCode',
    value: 'PropertySubTypeCode',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  }, {
    name: 'buildingName',
    value: 'buildingName',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  }, {
    name: 'buildingYear',
    value: 'buildingYear',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  }, {
    name: 'renovationYear',
    value: 'renovationYear',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  }, {
    name: 'MarketValue',
    value: 'MarketValue',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  }, {
    name: 'energyPerformanceLabel',
    value: 'energyPerformanceLabel',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  }, {
    name: 'energyCertificate',
    value: 'energyCertificate',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  }, {
    name: 'tenureId',
    value: 'tenureId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  }, {
    name: 'ProjectStdID',
    value: 'ProjectStdID',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  }, {
    name: 'PortfolioName',
    value: 'PortfolioName',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(50)]
  }, {
    name: 'linkToProjectFolder',
    value: 'linkToProjectFolder',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  }, {
    name: 'importName',
    value: 'importName',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  }, {
    name: 'Oid',
    value: 'Oid',
    disabled: true
  }, {
    name: 'NoJll',
    value: 'NoJll',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  }, {
    name: 'propertyIdJllHistoric',
    value: 'propertyIdJllHistoric',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  }, {
    name: 'propertyHorizonId',
    value: 'propertyHorizonId',
    disabled: true
  }, {
    name: 'propertyMDMId',
    value: 'propertyMDMId',
    disabled: true
  }, {
    name: 'opportunityPropertyId',
    value: 'opportunityPropertyId',
    disabled: true
  }, {
    name: 'NoNl',
    value: 'NoNl',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  }, {
    name: 'communityId',
    value: 'communityId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  }, {
    name: 'propertyDescription',
    value: 'propertyDescription',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  }, {
    name: 'comment',
    value: 'comment',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.maxLength(256)]
  }, {
    name: 'OwnerUserID',
    value: 'OwnerUserID',
    disabled: true
  }, {
    name: 'CreatedDate',
    value: 'CreatedDate',
    isDate: true,
    disabled: true
  }, {
    name: 'ModifiedByUserId',
    value: 'ModifiedByUserId',
    disabled: true
  }, {
    name: 'ModifiedDate',
    value: 'ModifiedDate',
    isDate: true,
    disabled: true
  }, { //required for Project retriever
    name: 'ProjectStdIDDescription',
    value: 'ProjectStdIDDescription',
    disabled: true
  }
];
